import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

interface HeroProps {
  title: string;
  subtitle: string;
  ctaText: string;
  ctaLink: string;
  secondaryCtaText?: string;
  secondaryCtaLink?: string;
  backgroundImage?: string;
}

const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  ctaText,
  ctaLink,
  secondaryCtaText,
  secondaryCtaLink,
  backgroundImage,
}) => {
  const bgStyle = backgroundImage
    ? {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    : {};

  const textColorClass = backgroundImage ? 'text-white' : 'text-gray-800';

  return (
    <div
      className="py-20 md:py-32 bg-snudefryd-beige"
      style={bgStyle}
    >
      <div className="container-custom text-center">
        <h1 className={`text-4xl md:text-5xl lg:text-6xl font-bold mb-6 ${textColorClass}`}>
          {title}
        </h1>
        <p className={`text-xl md:text-2xl mb-8 max-w-3xl mx-auto ${textColorClass}`}>
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to={ctaLink}>
            <Button size="lg">{ctaText}</Button>
          </Link>
          {secondaryCtaText && secondaryCtaLink && (
            <Link to={secondaryCtaLink}>
              <Button variant="outline" size="lg">
                {secondaryCtaText}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero; 